interface IDictionary {
  /** dynamic access */
  [key: string]: any;

  add(key: string, value: any): void;
  remove(key: string): void;
  containsKey(key: string): boolean;
  keys(): string[];
  values(): any[];
}

// -----------------------------------------------------------------------------
// Minimal key‑value store; now both the **class** and the **interface** expose an
// index signature so callers like `topNavigationUrls["/news"]` type‑check cleanly.
// -----------------------------------------------------------------------------
export default class Dictionary implements IDictionary {
  // TS requires the index signature to live on the class as well
  [key: string]: any;

  private internalKeys: string[] = [];
  private internalValues: any[] = [];

  constructor(init: Array<{ key: string; value: any }> = []) {
    for (const { key, value } of init) {
      this[key] = value;
      this.internalKeys.push(key);
      this.internalValues.push(value);
    }
  }

  public add(key: string, value: any): void {
    if (!this.containsKey(key)) {
      this.internalKeys.push(key);
    }
    this[key] = value;
    this.internalValues = this.internalKeys.map(k => this[k]);
  }

  public remove(key: string): void {
    const idx = this.internalKeys.indexOf(key);
    if (idx > -1) {
      this.internalKeys.splice(idx, 1);
      this.internalValues.splice(idx, 1);
      delete this[key];
    }
  }

  public containsKey(key: string): boolean {
    return Object.prototype.hasOwnProperty.call(this, key);
  }

  public keys(): string[] {
    return [...this.internalKeys];
  }

  public values(): any[] {
    return this.internalKeys.map(k => this[k]);
  }

  public toLookup(): IDictionary {
    return this; // now safe because IDictionary has the same index signature
  }
}



// WEBPACK FOOTER //
// ./src/api/dictionary.ts